import React from 'react';

export const CompassSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_17731_60856)">
      <path
        d="M11.8359 12.961C11.676 12.961 11.516 12.9 11.394 12.7779L7.72214 9.10601C7.47804 8.86194 7.47804 8.4662 7.72214 8.22214C7.9662 7.97804 8.36194 7.97804 8.60601 8.22214L12.2779 11.894C12.522 12.1381 12.522 12.5338 12.2779 12.7779C12.1558 12.9 11.9959 12.961 11.8359 12.961Z"
        fill="black"
      />
      <path
        d="M5.62514 15.5C5.46237 15.5 5.30256 15.4364 5.18307 15.3169C5.00631 15.1401 4.95186 14.875 5.04471 14.6429L7.54471 8.39288C7.60823 8.23409 7.73409 8.10823 7.89288 8.04471L14.1429 5.54471C14.3751 5.45186 14.6401 5.50631 14.8169 5.68307C14.9937 5.85987 15.0482 6.12499 14.9553 6.35713L12.4553 12.6071C12.3918 12.7659 12.2659 12.8918 12.1071 12.9553L5.85713 15.4553C5.7819 15.4854 5.70319 15.5 5.62514 15.5ZM8.60584 9.10584L6.74694 13.7531L11.3942 11.8942L13.2531 7.24694L8.60584 9.10584Z"
        fill="black"
      />
      <path
        d="M10 20.5C7.32891 20.5 4.8177 19.4598 2.92891 17.5711C1.04012 15.6823 0 13.1711 0 10.5C0 7.82891 1.04016 5.3177 2.92891 3.42891C4.81766 1.54012 7.32891 0.5 10 0.5C12.6711 0.5 15.1823 1.54016 17.0711 3.42891C18.9599 5.31766 20 7.82891 20 10.5C20 13.1711 18.9598 15.6823 17.0711 17.5711C15.1823 19.4599 12.6711 20.5 10 20.5ZM10 1.75C5.17523 1.75 1.25 5.67523 1.25 10.5C1.25 15.3248 5.17523 19.25 10 19.25C14.8248 19.25 18.75 15.3248 18.75 10.5C18.75 5.67523 14.8248 1.75 10 1.75Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_17731_60856">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default CompassSvg;
